/* eslint-disable import/prefer-default-export */
import getQuery from '../../utilities/query';
import { user, transactions } from '../../api';
import { handleError } from '../../utilities/errorHandling';

const queryClient = getQuery();

export const WALLETS_ALL = 'wallets.all';
export const BANK_REFERENCE = 'transactions.bank_reference';
export const GET_WHITELIST_ADDRESSES = 'user.getWhitelistAddresses';
export const GET_LAST_USED_WHITELIST_ADDRESS = 'user.getLastUsedWhitelistAddress';

queryClient.setQueryDefaults(GET_LAST_USED_WHITELIST_ADDRESS, {
  queryFn: ({ queryKey }) => {
    const { coin_id: coinId } = queryKey[1];
    return user.getLastUsedWhitelistAddress({ coin_id: coinId });
  },
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setQueryDefaults(GET_WHITELIST_ADDRESSES, {
  queryFn: ({ queryKey }) => {
    const { coin_id: coinId } = queryKey[1];
    return user.getWhitelistAddresses({ coin_id: coinId });
  },
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setQueryDefaults(WALLETS_ALL, {
  queryFn: async () => {
    const { wallets } = await user.wallets();
    return wallets;
  },
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setQueryDefaults(BANK_REFERENCE, {
  queryFn: async ({ queryKey }) => {
    const { reference } = await transactions.bankReference(queryKey[1]);
    return reference;
  },
  onError: (error) => {
    handleError(error);
  },
});
